import React from 'react';

const Admin = () => {
  return <div>modo admin</div>;
};

export default Admin
